import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { Scale, Menu, X, ExternalLink } from 'lucide-react'
import GlassContainer from '../ui/GlassContainer'

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)
  const toggleMobileMenu = () => setIsMobileMenuOpen(!isMobileMenuOpen)
  const closeMobileMenu = () => setIsMobileMenuOpen(false)

  return (
    <header className="relative z-50 py-4">
      <div className="container mx-auto px-4">
        <GlassContainer variant="subtle" className="px-6 py-4">
          <nav className="flex items-center justify-between">
            <Link to="/" className="flex items-center space-x-3 text-text-primary hover:text-white transition-colors" onClick={closeMobileMenu}>
              <Scale className="w-8 h-8" />
              <span className="text-xl font-bold">CongressMCP</span>
            </Link>

            <div className="hidden md:flex items-center space-x-6">
              <Link to="/setup" className="text-text-secondary hover:text-text-primary transition-colors">
                Setup Guide
              </Link>
              <a href="https://github.com/amurshak/congressMCP" target="_blank" rel="noopener noreferrer" className="flex items-center space-x-2 text-text-secondary hover:text-text-primary transition-colors">
                <span>GitHub</span>
                <ExternalLink className="w-4 h-4" />
              </a>
            </div>

            <div className="md:hidden">
              <button onClick={toggleMobileMenu} className="text-text-secondary hover:text-text-primary transition-colors p-2" aria-label="Toggle mobile menu">
                {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
              </button>
            </div>
          </nav>

          {isMobileMenuOpen && (
            <div className="md:hidden mt-4 pt-4 border-t border-glass-border">
              <div className="flex flex-col space-y-4">
                <Link to="/setup" className="text-text-secondary hover:text-text-primary transition-colors py-2" onClick={closeMobileMenu}>
                  Setup Guide
                </Link>
                <a href="https://github.com/amurshak/congressMCP" target="_blank" rel="noopener noreferrer" className="flex items-center space-x-2 text-text-secondary hover:text-text-primary transition-colors py-2" onClick={closeMobileMenu}>
                  <span>GitHub</span>
                  <ExternalLink className="w-4 h-4" />
                </a>
              </div>
            </div>
          )}
        </GlassContainer>
      </div>
    </header>
  )
}

export default Header
